import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.scss";

import { tt } from "../../../utils/i18n/i18n";
import KCErrorMessage from "../KCTexts/KCErrorMessage";

interface KCInputPropsI {
  id?: string;
  name: string;
  value?: string | number | undefined;
  label?: string;
  placeholder?: string;
  type?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  maxLength?: number | undefined;
  error?: string | undefined;
  disabled?: boolean;
  min?: number;
  innerIconEl?: JSX.Element | undefined;
  extraInputStyle?: any;
  margin?: number;
  onClick?: () => void;
}

const KCInput = ({
  id,
  name,
  value,
  type = "text",
  label,
  placeholder = tt("kc_input_placeholder"),
  onChange,
  onBlur,
  maxLength,
  error,
  disabled = false,
  min = 0,
  innerIconEl,
  extraInputStyle,
  margin,
  onClick
}: KCInputPropsI) => {
  const [visibility, setVisibility] = useState<boolean>(false);

  function handleVisibility() {
    setVisibility((previousVisibility: boolean) => !previousVisibility);
  }

  return (
    <Form.Group
      style={{ width: "100%", margin: margin || "inherit" }}
      onClick={onClick}
    >
      {!!label && <Form.Label className="custom-text">{label}</Form.Label>}
      <div className="kc-input-wrapper">
        <div className="kc-input-input">
          <InputGroup
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Form.Control
              style={{
                paddingRight: innerIconEl != null ? "40px" : "auto",
                textDecoration: "ellipsis",
                ...extraInputStyle
              }}
              id={id}
              name={name}
              type={type === "password" && visibility ? "text" : type}
              required={false}
              value={value}
              placeholder={placeholder}
              onChange={function (e: React.ChangeEvent<HTMLInputElement>) {
                onChange?.(e);
              }}
              onBlur={onBlur}
              maxLength={maxLength}
              disabled={disabled}
              min={min}
            />
            {innerIconEl}
          </InputGroup>
        </div>
        {type === "password" ? (
          <div className="kc-input-icon-container">
            <FontAwesomeIcon
              color="grey"
              onClick={handleVisibility}
              icon={visibility ? faEyeSlash : faEye}
              title="visibility"
              size="lg"
            />
          </div>
        ) : null}
      </div>
      {!!error && (
        <div className="mt-2">
          <KCErrorMessage id={id}>{error}</KCErrorMessage>
        </div>
      )}
    </Form.Group>
  );
};

export default KCInput;
